import type { Event, Disposable } from '@patsnap/tahiti-core';
import type {
    ParagraphIssueGroup,
    SpecChapterParagraphIssue,
} from '../types';

/**
 * 问题管理服务接口
 * 负责管理校对过程中的问题状态和业务逻辑
 */
export interface IssuesManagementService extends Disposable {
    // 状态查询
    getIssueGroups(): ParagraphIssueGroup[];
    getFilteredIssueGroups(): ParagraphIssueGroup[];
    hasIssuesData(): boolean;
    getTotalIssues(): number;
    getActiveParagraphIssueGroup(): ParagraphIssueGroup | undefined;
    getRemainingIssuesByParagraph(paragraphIndex: string): number;
    getIssueGroupByParagraphIndex(paragraphIndex: string): ParagraphIssueGroup | null;

    // 业务操作
    init(): Promise<void>;
    fetchIssues(): void;
    setIssueGroupActive(issueGroup: ParagraphIssueGroup): void;
    setIssueGroupActiveById(paragraphIndex: string, whenActive?: () => void): void;
    setIssueGroupGenerating(issueGroup: ParagraphIssueGroup | undefined): void;
    setIssueGroupFixing(issueGroup: ParagraphIssueGroup | undefined): void;
    ignoreParagraphIssues(issueGroup: ParagraphIssueGroup): Promise<void>;
    ignoreIssue(issue: SpecChapterParagraphIssue, issueGroup: ParagraphIssueGroup): Promise<void>;
    resolveCurrentAndNext(currentIssue: ParagraphIssueGroup): ParagraphIssueGroup | undefined;

    // 事件接口
    readonly onIssuesChanged: Event<ParagraphIssueGroup[]>;
    readonly onIssuesDataStatusChanged: Event<{ isLoading: boolean }>;
    readonly onFetchingStatusChanged: Event<{ isFetching: boolean, done: boolean }>;
    readonly onActiveIssueChanged: Event<{ activeIssue: ParagraphIssueGroup | undefined }>;
    readonly onGeneratingIssueChanged: Event<{ generatingIssue: ParagraphIssueGroup | undefined }>;
    readonly onFixingIssueChanged: Event<{ fixingIssue: ParagraphIssueGroup | undefined }>;
    readonly onTotalIssuesChanged: Event<{ total: number }>;
    readonly onError: Event<{ error: Error; context: string; recoverable: boolean }>;
}

export const IssuesManagementService = Symbol.for('IssuesManagementService');
